import Core from './Core';
import Geometry from './Geometry';
import Legacy from './Legacy';
import Misc from './Misc';
import XML from './XML';

export default {
  Core,
  Geometry,
  Legacy,
  Misc,
  XML,
};
